import { Input } from 'antd'

const { TextArea: AntdTextArea } = Input

export const TextArea = (props: any) => {
  const { label } = props

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      {label && (
        <div style={{ width: 200, justifyItems: 'flex-end' }}>
          <span>{label}:</span>
        </div>
      )}
      <div style={{ width: '100%' }}>
        <AntdTextArea {...props} />
      </div>
    </div>
  )
}

TextArea.defaultProps = {
  style: {
    width: '100%',
    marginBottom: 20
  }
}
